import styled from "styled-components";
import {Flex} from "./flex";

export const FlexJustifyAround = styled(Flex)`
    justify-content: space-around;
`;
